import { Card, Col, Row } from "antd";
import dayjs from "dayjs";
import type { Audit } from "../../../types/audits";
import spacing from "../../../components/ui/spacingConfig";

type Props = {
  auditData: Audit | undefined;
  className?: string;
};

const CardDetailsAudit: React.FC<Props> = ({ auditData, className }) => {
  return (
    <Card title="DÃ©tails" bordered={false} className={className}>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Site</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{auditData?.site?.name || "-"}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Type d'audit</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">
            {auditData?.audit_type?.name || "-"}
          </p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de l'audit</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">
            {auditData?.dateAudit
              ? dayjs(auditData.dateAudit).format("DD/MM/YYYY")
              : "-"}
          </p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Groupe de partage</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">
            {auditData?.accessRoleGivenTo?.length
              ? auditData.accessRoleGivenTo
                  .map((role) => role.displayName)
                  .join(", ")
              : "-"}
          </p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">PartagÃ© Ã </p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">
            {auditData?.accessGivenTo?.length
              ? auditData.accessGivenTo.map((user) => user.fullname).join(", ")
              : "-"}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDetailsAudit;
